import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import { utcToLocalDateTimeFormat } from '../../helpers/timeHelper'
import { StatusPill } from '../common/statusPill'
import { TaskAdminDropdown } from './taskAdminDropdown'

import { Task } from './types'
import { User, Vehicle } from '../../core/types'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  reassignTask: Callback
  adminUsers: User[]
  pageTitle: string
  pendingAt: string
  assignee: User
  vehicle: Vehicle
  taskStatus: string
  task: Task
  link: string | null
}

export const TaskHeader: FunctionComponent<Props> = ({
  pageTitle,
  assignee,
  adminUsers,
  vehicle,
  taskStatus,
  task,
  link,
  pendingAt,
  reassignTask,
}) => {
  return (
    <div className="task-modify__header">
      <div className="task-modify__type-info">
        <div className="task-modify__type-info--primary">
          <h2 className="task-modify__type-info--task">{pageTitle}</h2>
          <StatusPill
            withIcon
            status={taskStatus && taskStatus.toUpperCase()}
          />
        </div>
        <div className="task-modify__type-info--secondary">
          <TaskAdminDropdown
            adminUsers={adminUsers}
            assignee={assignee}
            reassignTask={reassignTask}
            label="Assigned to"
          />
          <p className="task-modify__type-info--text">
            {utcToLocalDateTimeFormat(pendingAt)}
          </p>
        </div>
      </div>

      <div className="task-modify__info">
        {task && task.subject && task.subject.id !== task.user.id && (
          <div className="task-modify__info--row">
            <div>Coapp Name</div>
            <Link to={`/users/${task.subject.id}`}>
              {`${task.subject.lastName}, ${task.subject.firstName}`}
            </Link>
          </div>
        )}
        {vehicle && vehicle.vin && vehicle.id && (
          <div className="task-modify__info--row">
            <div>VIN number</div>
            <Link to={`/vehicles/${vehicle.id}`}>{vehicle.vin}</Link>
          </div>
        )}
        {link && (
          <div className="task-modify__info--row">
            <div>Transaction ID</div>
            <a href={link}>{task.entityId}</a>
          </div>
        )}
      </div>
    </div>
  )
}

TaskHeader.displayName = 'TaskHeader'
